// extracted by mini-css-extract-plugin
export default {"wrapper":"AppTextInput_wrapper__DIdqN","label":"AppTextInput_label__AjVlt","required":"AppTextInput_required__YQK6V","errorText":"AppTextInput_errorText__n7RQD"};